import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-purchaseorder',
  templateUrl: './purchaseorder.component.html',
  styleUrls: ['./purchaseorder.component.css']
})
export class PurchaseorderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
